export default __webpack_public_path__ + "static/media/Akansha.1866a600.jpeg";